import { Navigate, createBrowserRouter } from "react-router-dom";
import { lazy } from "react";
import Protected from "./Protected";
import GuestRoutes from "./GuestRoutes";
import ContentManager from "../pages/authenticated/ContentManager";
import ContentPages from "../pages/ContentPages";
import axios from "axios";

const NotFound = lazy(() => import("../pages/common/NotFound"));

const SmsContent = lazy(() => import("../pages/smswork/SMSContent"));

const Register = lazy(() => import("../pages/auth/Register"));
const Login = lazy(() => import("../pages/auth/Login"));
const Forgot = lazy(() => import("../pages/auth/Forgot"));
const Reset = lazy(() => import("../pages/auth/Reset"));
const Dashboard = lazy(
  () => import("../pages/authenticated/dashboard/Dashboard"),
);
const UsersData = lazy(() => import("../pages/authenticated/UsersData"));
const Profile = lazy(() => import("../pages/authenticated/Profile"));
const Groups = lazy(() => import("../pages/authenticated/group/Groups"));
const AddGroup = lazy(() => import("../pages/authenticated/group/AddGroup"));
const EditGroup = lazy(() => import("../pages/authenticated/group/EditGroup"));
const Content = lazy(() => import("../pages/authenticated/content/Content"));
const Banners = lazy(() => import("../pages/authenticated/banners/Banners"));
const NewContent = lazy(
  () => import("../pages/authenticated/content/NewContent"),
);
const EditContent = lazy(
  () => import("../pages/authenticated/content/EditContent"),
);
const SoundCategory = lazy(
  () => import("../pages/authenticated/soundCategory/SoundCategory"),
);
const Sounds = lazy(
  () => import("../pages/authenticated/soundCategory/Sounds"),
);

const Categories = lazy(
  () => import("../pages/authenticated/categories/Categories"),
);
const LevelControl = lazy(
  () => import("../pages/authenticated/eventControl/EventControl"),
);
const AddEventDetails = lazy(
  () => import("../pages/authenticated/eventControl/AddEventDetail"),
);
const EditEventDetails = lazy(
  () => import("../pages/authenticated/eventControl/EditEventDetail"),
);
const InviteEvent = lazy(
  () => import("../pages/authenticated/eventControl/InviteEvent"),
);

const Screen1 = lazy(() => import("../pages/screens/Screen1"));
const Screen2 = lazy(() => import("../pages/screens/Screen2"));

const ThemeList = lazy(() => import("../pages/authenticated/theme/Theme"));
const AddTheme = lazy(() => import("../pages/authenticated/theme/AddTheme"));
const EditTheme = lazy(() => import("../pages/authenticated/theme/EditTheme"));

const Organizers = lazy(() => import("../pages/organizers/Organizers"));
const OrganizerEvent = lazy(() => import("../pages/organizers/OragnizerEvent"));

const RoleList = lazy(() => import("../pages/authenticated/roles/Roles"));
const AddRole = lazy(() => import("../pages/authenticated/roles/AddRole"));
const EditRole = lazy(() => import("../pages/authenticated/roles/EditRole"));

const Questions = lazy(
  () => import("../pages/authenticated/question/Questions"),
);
const AddQuestion = lazy(
  () => import("../pages/authenticated/question/AddQuestion"),
);
const EditQuestions = lazy(
  () => import("../pages/authenticated/question/EditQuestion"),
);
const Preference = lazy(
  () => import("../pages/authenticated/preference/Preference"),
);
const Subscription = lazy(
  () => import("../pages/authenticated/subscription/Subscription"),
);
const FAQ = lazy(() => import("../pages/authenticated/faq/FAQ"));
const AddFAQ = lazy(() => import("../pages/authenticated/faq/AddFAQ"));
const EditFAQ = lazy(() => import("../pages/authenticated/faq/EditFAQ"));
const SubscriptionCategory = lazy(
  () => import("../pages/authenticated/SubscriptionCategory"),
);

const Feedbacks = lazy(
  () => import("../pages/authenticated/feedbacks/Feedbacks"),
);
const View = lazy(() => import("../pages/authenticated/feedbacks/View"));
const ContactUs = lazy(
  () => import("../pages/authenticated/contactus/ContactUs"),
);
const Contact = lazy(() => import("../pages/authenticated/contactus/Contact"));
const AppSetting = lazy(
  () => import("../pages/authenticated/appSetting/AppSetting"),
);
const LoginTrouble = lazy(
  () => import("../pages/authenticated/loginTrouble/LoginTrouble"),
);
const AddNewLoginTrouble = lazy(
  () => import("../pages/authenticated/loginTrouble/AddNewLoginTrouble"),
);
const EditLoginTrouble = lazy(
  () => import("../pages/authenticated/loginTrouble/EditLoginTrouble"),
);
const UsersSubscription = lazy(
  () => import("../pages/authenticated/usersSubscription/UsersSubscription"),
);
const ReportedUsers = lazy(
  () => import("../pages/authenticated/reportedUsers/ReportedUsers"),
);
const UserAccountDelete = lazy(
  () => import("../pages/authenticated/UserAccountDelete"),
);
const DeleteUrl = lazy(() => import("../pages/DeleteUrl"));
const DeletedRequests = lazy(
  () => import("../pages/authenticated/DeletedRequests"),
);

// axios.defaults.baseURL = "http://44.195.125.80:9719/api/v1";
// axios.defaults.baseURL = "http://localhost:9719/api/v1/";

const routes = createBrowserRouter(
  [
    {
      path: "/",
      element: <Navigate to={"/auth/login"} />,
    },
    
    {
      path: "delete-user-account",
      Component: UserAccountDelete,
    },
    {
      path: "deleted-url",
      Component: DeleteUrl,
    },
    // {
    //   path: "deleted-url",
    //   Component: DeleteUrl,
    // },
    {
      path: "sms-content",
      Component: SmsContent,
    },
    {
      path: "content-pages/:key",
      Component: ContentPages,
    },
    {
      path: "contact-us",
      Component: ContactUs,
    },
    {
      path: "/auth",
      Component: GuestRoutes,
      children: [
        {
          path: "",
          element: <Navigate to={"login"} />,
        },
        {
          path: "register",
          Component: Register,
        },
        {
          path: "login",
          Component: Login,
        },
        {
          path: "forgot",
          Component: Forgot,
        },
        {
          path: "reset",
          Component: Reset,
        },
      ],
    },
    {
      path: "/",
      Component: Protected,
      children: [
        {
          path: "dashboard",
          Component: Dashboard,
        },
        {
          path: "users",
          Component: UsersData,
        },
        {
          path: "content",
          Component: Content,
        },
        {
          path: "content/new-content",
          Component: NewContent,
        },
        {
          path: "content/edit-content/:id",
          Component: EditContent,
        },
        {
          path: "sound-categories",
          Component: SoundCategory,
        },
        {
          path: "sound-categories/:id",
          Component: Sounds,
        },
        {
          path: "event-control",
          Component: LevelControl,
        },
        {
          path: "event-control/add-event-details",
          Component: AddEventDetails,
        },
        {
          path: "event-control/edit-event-details/:id",
          Component: EditEventDetails,
        },
        {
          path: "event-control/invite-event/:id",
          Component: InviteEvent,
        },
        {
          path: "theme-list",
          Component: ThemeList,
        },
        {
          path: "theme-list/add-theme",
          Component: AddTheme,
        },
        {
          path: "theme-list/edit-theme/:id",
          Component: EditTheme,
        },
        {
          path: "/screen-login",
          Component: Screen1,
        },
        {
          path: "/screen-chat",
          Component: Screen2,
        },
        {
          path: "/roles",
          Component: RoleList,
        },
        {
          path: "/roles/add-role",
          Component: AddRole,
        },
        {
          path: "/roles/edit-role/:id",
          Component: EditRole,
        },
        {
          path: "/subscription-management",
          Component: UsersSubscription,
        },
        {
          path: "deleted-requests",
          Component: DeletedRequests,
        },
        // {
        //   path: "level-control/edit-level-details/:id",
        //   Component: EditLevelDetails,
        // },
        // {
        //   path: "banners/add-banner",
        //   Component: AddBanner,
        // },
        // {
        //   path: "questions/edit-question/:id",
        //   Component: EditQuestions,
        // },
      ],
    },
    {
      path: "*",
      Component: NotFound,
    },
  ],
  {
    basename: "/admin-panel", // <-- Replace with your actual base path
  },
);

export default routes;
